module.exports = __webpack_public_path__ + "media/images/flags/64/British-Antarctic-Territory-65011d9c75b045df5ec405ce9e213710.png";